import { render, staticRenderFns } from "./PackingIndex.vue?vue&type=template&id=225dd6ab&scoped=true"
import script from "./PackingIndex.vue?vue&type=script&lang=js"
export * from "./PackingIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225dd6ab",
  null
  
)

export default component.exports